import { CloseOutlined, LoadingOutlined } from "@ant-design/icons";
import { API } from "aws-amplify";
import React, { ReactNode, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import config from "../../aws-exports";
import { ImageFile } from "../../interfaces";

var request: XMLHttpRequest | null = null;

type Props = {
  files: ImageFile[];
  setFiles: (files: ImageFile[]) => void;
  children: ReactNode;
};

const UploadAttachment: React.FC<Props> = ({ files, setFiles, children }) => {
  const { t } = useTranslation();
  const [completedFiles, setCompletedFiles] = useState<{
    [key: string]: string;
  }>(
    Object.fromEntries(new Map(files?.map((_file) => [_file.key, _file.key])))
  );
  const inputRef: any = useRef();

  const handleUpload = () => {
    inputRef.current.click();
  };

  const handleS3Upload = async (file: File) => {
    const name = file?.name;
    const key = `${Date.now()}-${name}`;
    const region = config.aws_user_files_s3_bucket_region;
    const bucketName = config.aws_user_files_s3_bucket;

    setFiles([...files, { key, name }]);

    const signedUrl = await API.get(
      "s3UploadApi",
      `/?fileName=public/${key}&region=${region}&bucketName=${bucketName}`,
      {}
    );

    request = new XMLHttpRequest();
    request.responseType = "json";

    request.addEventListener("load", async () => {
      if (request?.status === 200) {
        setCompletedFiles({ ...completedFiles, [key]: key });
        request = null;
      } else {
        request = null;
      }
    });

    request.addEventListener("error", (e: any) => {
      request = null;
      console.log("error:", e);
    });

    request.open("put", signedUrl);
    request.send(file);
  };

  const onInputChange = (e: any) => {
    const file = e.target.files[0];
    e.target.value = null;

    if (!/pdf/.test(file?.type)) {
      toast.warn(t("pdfAllowed", { name: file.name }));
      return;
    }

    handleS3Upload(file);
  };

  return (
    <div className="w-sx">
      <input
        accept=".png, .jpeg, .jpg, .pdf, .epub"
        style={{ display: "none" }}
        ref={inputRef}
        type="file"
        onChange={onInputChange}
      />

      <div className="image-files mt-10">
        <span onClick={handleUpload}>{children}</span>
        {files.map((file) => (
          <div className="image-files__file">
            <span>
              {!completedFiles[file.key] && (
                <LoadingOutlined style={{ marginRight: 5 }} />
              )}
              <span>{file.name}</span>
            </span>
            <CloseOutlined
              onClick={() =>
                setFiles(files.filter((_file) => _file?.key !== file?.key))
              }
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default UploadAttachment;
